import script from "./VoucherCountByYearChart.vue?vue&type=script&setup=true&lang=js"
export * from "./VoucherCountByYearChart.vue?vue&type=script&setup=true&lang=js"

import "./VoucherCountByYearChart.vue?vue&type=style&index=0&id=45c820ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c820ae"]])

export default __exports__